import { getAllCategoriesByType } from "@/utils/rezeptAPI/getAllCategoriesByType";
import { CategoryType } from "../types/baseTypes";
import { fetchFromVolatileServer } from "../utils/fetchFromVolatileServer";
import { getUrl } from "../utils/url";

/**
 * @param category the category you want to get...
 * @param locale  optional if not given falls back to default locale
 * @param defaultLocale optional if not given falls back to default locale
 * @returns {Promise<*>}
 */
export const getCategories = async ({
  category,
  locale,
  defaultLocale,
}: {
  category: string;
  locale?: string;
  defaultLocale?: string;
}) => {
  const categoryRes = await fetchFromVolatileServer(
    getUrl(locale, defaultLocale) + "/" + category,
  );
  const categories: CategoryType[] = await categoryRes.json();
  const newCat = categories.map((cat) => {
    if (cat.acf.link) {
      cat.acf.link = new URL(cat.acf.link).pathname;
    }
    return cat;
  });
  return newCat;
};

export const getCategoryByTypeAndID = async (
  categoryType: string,
  idTipTopfKategorie: string,
  lang?: string,
  defaultLang?: string,
) => {
  const categoryRes = await fetchFromVolatileServer(
    getUrl(lang, defaultLang) + "/" + categoryType + "?per_page=100",
  );
  const categories = await categoryRes.json();
  if (categories && categories.length) {
    const selectedCategory = categories?.find((cat: CategoryType) => {
      return cat.acf.id == idTipTopfKategorie;
    });
    return selectedCategory || null;
  }
};

export const categoryTypes = {
  dietTypes: "diet_types",
  categories: "categories_tiptopf",
  cookingMethods: "cooking_methods",
  seasons: "saisons",
};

// maps taxonomy type to filter page parameter
export function getFilterParamForCategoryTaxonomy(taxonomyType: string) {
  if (taxonomyType === categoryTypes.dietTypes) {
    return "filterErnaehrungsform";
  } else if (taxonomyType === categoryTypes.cookingMethods) {
    return "filterGarmethode";
  } else if (taxonomyType === categoryTypes.seasons) {
    return "filterSaisons";
  } else if (taxonomyType === "categories") {
    return "filterKategorie";
  }
  return null;
}

export const findCategory = async (
  categoryId: string,
  lang?: string,
  defaultLang?: string,
) => {
  let categoryData = await getCategoryByTypeAndID(
    categoryTypes.categories,
    categoryId,
    lang,
    defaultLang,
  );
  if (!categoryData) {
    categoryData = await getCategoryByTypeAndID(
      categoryTypes.dietTypes,
      categoryId,
      lang,
      defaultLang,
    );
  }
  return categoryData;
};

interface TipTopfKategorie {
  rezept_print_kategorie_id: number;
  print_kategorie: string;
  kategorie_id: number;
  kategorie_titel: string;
}
interface TipTopfSaison {
  saison_id: number;
  saison_titel: string;
}
interface TipTopfErnaehrungsform {
  ernaehrungsform_id: number;
  ernaehrungsform_titel: string;
}
interface TipTopfGarmethode {
  garmethode_id: number;
  garmethode_titel: string;
}

export const getCategoriesWithToken = async (
  categoryType: string,
  token: string,
) => {
  const categoryRes = await fetchFromVolatileServer(
    getUrl() + "/" + categoryType + "?per_page=100",
  );
  const wpResponse = await categoryRes.json();
  const categoryResTiptopf = await getAllCategoriesByType(token, categoryType);
  // map the id of the default language to the other language
  const categoryResTiptopfArray =
    categoryResTiptopf?.kategorien ||
    categoryResTiptopf?.saisons ||
    categoryResTiptopf?.ernaehrungsformen ||
    categoryResTiptopf?.garmethoden;
  return wpResponse?.map?.((wpCat: CategoryType) => {
    const matchedCategoryTiptopf = categoryResTiptopfArray?.find?.(
      (
        catTiptopf: TipTopfKategorie &
          TipTopfSaison &
          TipTopfErnaehrungsform &
          TipTopfGarmethode,
      ) => {
        const wpID = parseInt(wpCat.acf.id, 10);
        return (
          wpID == catTiptopf.kategorie_id ||
          wpID == catTiptopf.rezept_print_kategorie_id ||
          wpID == catTiptopf.saison_id ||
          wpID == catTiptopf.ernaehrungsform_id ||
          wpID == catTiptopf.garmethode_id
        );
      },
    );
    if (matchedCategoryTiptopf) {
      const nameFromTiptopf =
        matchedCategoryTiptopf?.kategorie_titel ||
        matchedCategoryTiptopf?.print_kategorie ||
        matchedCategoryTiptopf?.saison_titel ||
        matchedCategoryTiptopf?.ernaehrungsform_titel ||
        matchedCategoryTiptopf?.garmethode_titel;
      wpCat.name = nameFromTiptopf;
    }
    return wpCat;
  });
};
